// https://juristr.com/blog/2018/02/angular-permission-directive/
// <div *hasPermission="['can_write', 'can_read']; operation 'OR'">
//     Only users with "can_write AND "can_read" permissions can see this.
// </div>
import { Directive, Input, TemplateRef, ViewContainerRef, ElementRef, OnInit, Attribute } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AccountRepository } from 'src/app/auth/account/state/account.repository';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[hasPermission]',
})
export class HasPermissionDirective implements OnInit {
  private currentUser;
  private currentUserPermissions: string[] = [];
  private permissions = [];
  private logicalOp = 'AND';
  private isHidden = true;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private accountRepository: AccountRepository
  ) {}

  ngOnInit() {
    combineLatest([this.accountRepository.account$, this.accountRepository.permissions$]).subscribe(([user, permissions]) => {
      this.currentUser = user;
      this.currentUserPermissions = permissions;
      this.updateView();
    });
  }

  @Input()
  set hasPermission(val) {
    this.permissions = val;
    this.updateView();
  }

  @Input()
  set hasPermissionOp(permop) {
    this.logicalOp = permop;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    let hasPermission = false;

    if (this.currentUser && this.currentUserPermissions) {
      for (const checkPermission of this.permissions) {
        const permissionFound = this.currentUserPermissions.find((x) => x.toUpperCase() === checkPermission.toUpperCase());

        if (permissionFound) {
          hasPermission = true;

          if (this.logicalOp === 'OR') {
            break;
          }
        } else {
          hasPermission = false;
          if (this.logicalOp === 'AND') {
            break;
          }
        }
      }
    }

    return hasPermission;
  }
}
